import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { SendFileQueryParams, SendMessageQueryParams } from "../../../../types/telegram-page.types";
import { TelegramChatWindowService } from "../../../../services/telegram-chat-window.service";
import { ChatTelegram } from "../../../../types/chat-telegram.types";
import { TelegramAccountsService } from "../../../../services/telegram-accounts.service";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatFormField, MatInput, MatLabel } from "@angular/material/input";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'app-telegram-send-message',
  standalone: true,
  imports: [
    MatIconButton,
    MatIcon,
    MatFormField,
    MatLabel,
    MatInput,
    CdkTextareaAutosize,
    FormsModule
  ],
  templateUrl: './telegram-send-message.component.html',
  styleUrl: './telegram-send-message.component.scss'
})
export class TelegramSendMessageComponent {
  @Input({ required: true }) selectedChat?: ChatTelegram | null;
  @Output() sendMessage: EventEmitter<SendMessageQueryParams> = new EventEmitter<SendMessageQueryParams>();

  private telegramChatWindowService: TelegramChatWindowService = inject(TelegramChatWindowService);
  private telegramAccountsService: TelegramAccountsService = inject(TelegramAccountsService);

  public newMessage: string = '';

  public async handleFileSelected(event: Event): Promise<void> {
    if (!this.selectedChat) { return; }

    const input = event.target as HTMLInputElement;
    if (!input?.files?.length) { return; }

    const selectedFile = input.files[0] as File;
    const fileValidationResult = this.telegramChatWindowService.validateFile(selectedFile);
    if (!fileValidationResult.isValid) {
      input.value = '';
      return;
    }

    const sendFileQueryParams = this.getSendFileQueryParams(selectedFile.name, this.selectedChat.id);
    await this.telegramChatWindowService.uploadFile({
      selectedFile: selectedFile,
      fileType: fileValidationResult.type,
      sendFileQueryParams: sendFileQueryParams,
    });

    input.value = '';
  }

  public handelSendMessage(): void {
    if (!this.newMessage.trim() || !this.selectedChat) {
      this.newMessage = '';
      return;
    }

    const sendMessageQueryParams: SendMessageQueryParams = {
      chatId: this.selectedChat.id,
      messageText: this.newMessage,
      accountId: this.telegramAccountsService.selectedAccount().accountId
    }

    this.sendMessage.emit(sendMessageQueryParams);
    this.newMessage = '';
  }

  private getSendFileQueryParams(fileName: string, chatId: number): SendFileQueryParams {
    return {
      chatId: chatId,
      message: this.newMessage,
      accountId: this.telegramAccountsService.selectedAccount().accountId,
      fileName: fileName
    };
  }
}
